module.exports = "<span class=\"abbreviation-lookup-link\">\r\n    <a href=\"{{Model.Url}}\" target=\"_blank\" title=\"Citation lookup: {{Model.Publisher.Name}}\" aria-label=\"Citation lookup: {{Model.Publisher.Name}}\">\r\n        <i class=\"fa fa-info-circle\" role=\"img\"></i>\r\n    </a>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/partials/abbreviation-lookup-link.html
// module id = 141
// module chunks = 1